<form novalidate #propertyPromoteSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <div class="property_promote_section">
      <tg-row>
        <tg-col sm="12">
          <h1 class="property-promote-section__title">
            Choose your listing type
          </h1>
          <p class="property-promote-section__lead-copy" [innerHtml]="pageSubTitle"></p>
        </tg-col>
      </tg-row>
      @if (showFeesInformation) {
        <tg-row>
          <tg-col md="6" sm="12">
            <div class="property-promote-section__feesInformationDiv">
              <label class="property-promote-section__feesInformationDiv__title">You have not provided a Capital value for
              your listing</label>
              <label class="property-promote-section__feesInformationDiv__text">
                Your listing fee is based on ‘No CV’, for more information see our fees page. If applicable, you can enter
                the CV on the Property information page.
              </label>
              <div class="property-promote-section__feesInformationDiv__link">
                <a href="https://help.trademe.co.nz/hc/en-us/articles/360032007872-Property-fees#h_ad3eee9a-0cb8-4114-a9f8-58a6c5d7289a"
                target="_blank" class="h-link-no-visited">See our fees page for more details</a>
              </div>
              <div class="property-promote-section__feesInformationDiv__link">
                <a routerLink="../{{ stepIds.propertyInformation }}" routerLinkActive="active" class="h-link-no-visited">Go
                back to Property information</a>
              </div>
            </div>
          </tg-col>
        </tg-row>
      }
      <tg-row class="property-promote-section__margin-bottom">
        <tg-col md="6" sm="12">
          @if (displayError && !isMobile) {
            <tg-info-box tgStyle="danger">
              <tg-icon name="camera" alt="information">
              </tg-icon>
              <tg-info-box-heading>
                You need to add at least
                {{ selectedBundle.minPhotoRequired }} photo(s) to select
                a {{ selectedBundle.name }} listing.
              </tg-info-box-heading>
              Select a different listing type or add more photos.
              <tg-info-box-actions>
                <button tgButton2 transparent routerLink="../{{ stepIds.propertyPhotos }}">
                  Add more photos
                </button>
              </tg-info-box-actions>
            </tg-info-box>
          }
          @for (fee of fees; track fee.id) {
<div (click)="setPhotos(fee.id); publish();handleChangeCategoryPackageId();" [ngClass]="{
                        'property-promote-section__disabled':
                            fee.isDisabled
                    }">
              @if (displayError &&
                isMobile &&
                fee.id === selectedBundle.id) {
                <tg-info-box tgStyle="danger">
                  <tg-icon name="camera" alt="information">
                  </tg-icon>
                  <tg-info-box-heading>
                    You need to add at least
                    {{ selectedBundle.minPhotoRequired }} photo(s) to
                    select a {{ selectedBundle.name }} listing.
                  </tg-info-box-heading>
                  Select a different listing type or add more photos.
                  <tg-info-box-actions>
                    <button tgButton2 transparent routerLink="../{{ stepIds.propertyPhotos }}">
                      Add more photos
                    </button>
                  </tg-info-box-actions>
                </tg-info-box>
              }
              <tg-card bordered class="property-promote-section__card"
                [ngClass]="{selectedCard: fee.id === selectedBundle.id}">
                <tg-row>
                  <tg-col md="7" sm="6">
                    <label class="container">
                      {{ fee.name }}
                  <input type="radio" [id]="fee.name" name="categoryPackageId" [value]="fee.id" [(ngModel)]="draftData.propertyPromote
                                                .categoryPackageId"
                        [validation]="validation.propertyPromote.categoryPackageId | toValidator">
                  <span [ngClass]="{
                        'disable': fee.isDisabled
                    }" class="checkmark"></span>
                      </label>
                    </tg-col>
                    <tg-col md="5" sm="6">
                      @if (fee.packagePrice) {
<div class="property-promote-section__priceDisplay" [innerHTML]="fee.packagePrice
                                            | tgCurrency
                                            | tmSupCurrency"></div>
                      }
                      @if (fee.packagePrice === 0) {
                        <div class="property-promote-section__yourPromotion">
                        {{zeroChargeMessage}}</div>
                      }
                    </tg-col>
                  </tg-row>
                  <tg-row>
                    <tg-col sm="12" class="property-promote-section__subTitle">
                      <span [innerHTML]="fee.description"></span>
                    </tg-col>
                  </tg-row>
                  <tg-row class="property-promote-section__bottomMargin">
                    <tg-col sm="12">
                      <ul tgList2 compact type="icon">
                        @for (detail of fee.details; track $index) {
                          <li [ngClass]="{ disabled: !detail.checked}">
                            {{ detail.description }}
                            @if (detail.checked) {
                              <tg-icon-left name="basic-tick" alt="tick" size="small">
                              </tg-icon-left>
                            }
                            @if (!detail.checked) {
                              <tg-icon-left name="basic-cross" alt="tick" size="small">
                              </tg-icon-left>
                            }
                          </li>
                        }
                      </ul>
                    </tg-col>
                  </tg-row>
                </tg-card>
                <tg-row>
                  <tg-col sm="12" class="property-promote-section__viewMore">
                    <button tgButton2 fullWidth (click)="openModal(fee.photos, fee.name)">
                      <tg-icon-left name="eye" alt="eye">
                      </tg-icon-left>
                      View Example
                    </button>
                  </tg-col>
                </tg-row>
              </div>
            }
          </tg-col>
          <tg-col md="6" class="property-promote-section__image-column">
            @for (photo of distinctPhotos; track photo.id) {
              <tg-row class="property-promote-section__images">
                <tg-col md="12">
                  @if (photo.selected) {
                    <label class="p-secondary-copy">
                      {{ photo.description }}
                    </label>
                  }
                  <img [ngClass]="{ blurred: !photo.selected }" src="./assets/images/{{ photo.url }}">
                </tg-col>
              </tg-row>
            }
          </tg-col>
        </tg-row>
        @if (isAllowDisplayReviewPromotionSection) {
          <tg-row class="property-promote-section__superfeature">
            <tg-col md="6" sm="12">
              <label class="property-promote-section__review-promotion-title">Renew promotion</label>
              <p>You can renew your expired promotional feature.</p>
              <tg-card bordered class="property-promote-section__card">
                <tg-row>
                  <tg-col md="8" sm="6">
                    <tg-checkbox name="hasSuperFeature" (change)="publish()"
                      [(ngModel)]="draftData.propertyPromote.hasSuperFeature">
                      <tg-label class="checkbox-label d-block">
                        Carousel
                      </tg-label>
                      <tg-label>
                        Super Feature<sup>3</sup>
                      </tg-label>
                    </tg-checkbox>
                  </tg-col>
                  <tg-col md="4" sm="6">
                    <div class="property-promote-section__priceDisplay"
                    [innerHTML]="superFeatureFee | tgCurrency | tmSupCurrency"></div>
                  </tg-col>
                </tg-row>
                <tg-row>
                  <tg-col sm="12" class="property-promote-section__subTitle">
                    <span>Appear in <b>carousel at top of search results</b> for 7 days</span>
                  </tg-col>
                </tg-row>
              </tg-card>
            </tg-col>
          </tg-row>
        }
        <tg-row>
          <tg-col sm="12" md="6">
            <small [innerHtml]="pageFooterNotes"></small>
          </tg-col>
        </tg-row>
        @if (showModal) {
          <tg-modal (close)="showModal = false" fullscreen>
            <tg-modal-header>
              <h2>View Example</h2>
              <h3>{{ packageName }}</h3>
            </tg-modal-header>
            <tg-modal-body>
              @for (photo of modalPhotos; track photo.id) {
                <tg-row class="property-promote-section__row-mobile-spacing">
                  <tg-col md="12">
                    <label class="p-secondary-copy">{{ photo.description }}</label>
                    <img src="./assets/images/{{ photo.url }}">
                  </tg-col>
                </tg-row>
              }
            </tg-modal-body>
            <tg-modal-footer></tg-modal-footer>
          </tg-modal>
        }
      </div>
    }
  </form>
